export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";